<template>
  <div class="case-panel" id="case">
    <!-- 标题 -->
    <div class="panel-header">
      <div class="left">
        <div class="panel-title">精选案例</div>

        <div class="panel-count">{{ filteredCaseList.length }} 个结果</div>
      </div>
    </div>

    <!-- 工具栏 -->
    <div class="toolbar">
      <!-- 左侧 -->
      <div class="toolbar-left">
        <a-checkbox v-model:checked="checkAll" @change="onCheckAll">
          全选当前列表
        </a-checkbox>

        <a-button
          @click="batchFavorite"
          @mouseenter="batchFavoriteHover = true"
          @mouseleave="batchFavoriteHover = false"
          class="btns"
        >
          <img
            :src="
              batchFavoriteHover
                ? require('@/assets/casesearchImg/i-star2.png')
                : require('@/assets/casesearchImg/i-star.png')
            "
            class="icons"
          />
          批量收藏
        </a-button>
        <a-button
          @click="handleBatchDownload"
          :loading="downloading"
          @mouseenter="downloadHover = true"
          @mouseleave="downloadHover = false"
        >
          <img
            :src="
              downloadHover
                ? require('@/assets/casesearchImg/i-download-two.png')
                : require('@/assets/casesearchImg/i-download.png')
            "
            class="icons"
          />
          批量下载
        </a-button>
      </div>

      <!-- 右侧 -->
      <div class="toolbar-right">
        <div class="year-select">
          <img
            src="@/assets/casesearchImg/i-calendar.png"
            class="calendar-icon"
          />

          <a-select
            v-model:value="innerYear"
            style="width: auto; min-width: 100px"
            placeholder="裁判年份"
            class="select-year"
            :dropdownStyle="{ maxHeight: '200px', overflow: 'auto' }"
            :allow-clear="
              innerYear === 0 ||
              innerYear === null ||
              innerYear === undefined ||
              yearUserChanged
            "
            @change="
              (val) => {
                emit('update:year', val);
                yearUserChanged = true;
              }
            "
          >
            <a-select-option
              v-for="item in yearOptions"
              :key="item.value"
              :value="item.value"
            >
              {{ item.label }}
            </a-select-option>
          </a-select>
        </div>

        <div class="select-wrapper">
          <img
            src="@/assets/casesearchImg/i-building.png"
            class="tree-select-icon"
          />

          <a-tree-select
            v-model:value="courtNames"
            style="width: 230px"
            :tree-data="courtTreeDataDisplay"
            placeholder="法院"
            :allow-clear="
              !courtNames || courtNames === '全部法院' || courtUserChanged
            "
            show-search
            tree-node-filter-prop="title"
            tree-default-expand-all
          />
        </div>
      </div>
    </div>
    <!-- Case -->

    <div class="card-list">
      <div
        v-for="(item, index) in filteredCaseList"
        :key="item.id"
        :data-case-index="index"
        class="case-card"
      >
        <div class="card-top">
          <a-checkbox v-model:checked="item.checked" />

          <div class="title-box">
            <div class="case-title">
              <div>{{ item.ah }}</div>
              <div class="case-right">
                <div class="right-img">
                  <!-- 召回率 / 相似度暂不展示（隐藏）
                  <div class="right-relevanceScore">
                    <span>召回率：</span><span class="relevance-bum">81%</span>
                  </div>
                  <div class="right-relevanceScore">
                    <span>相似度：</span
                    ><span class="relevance-bum">{{
                      item.relevanceScore
                    }}</span>
                  </div>
                  -->
                  <SvgIcon
                    name="collect"
                    :size="16"
                    class="right-icon"
                    :class="{ 'is-favorited': item.isFavorited }"
                    @click.stop="toggleFavorite(item)"
                  />
                </div>
              </div>
            </div>

            <div class="case-meta">
              {{ item.court }}
            </div>
          </div>
        </div>

        <div>
          <!-- 标签 -->

          <div class="tag-box">
            <a-tabs
              :activeKey="activeKeyMap[item.id] || '案情摘要'"
              @change="(key) => (activeKeyMap[item.id] = key)"
            >
              <a-tab-pane v-for="tag in item.tags" :key="tag" :tab="tag">
                <div
                  class="summary"
                  v-if="
                    activeKeyMap[item.id] === '案情摘要' ||
                    (!activeKeyMap[item.id] && tag === '案情摘要')
                  "
                >
                  {{ item.caseSummary }}
                </div>
                <div
                  class="summary"
                  v-if="activeKeyMap[item.id] === '认定事实'"
                >
                  {{ item.facts }}
                </div>
                <div
                  class="summary"
                  v-if="activeKeyMap[item.id] === '本院认为'"
                >
                  {{ item.courtOpinion }}
                </div>
                <div
                  class="summary"
                  v-if="activeKeyMap[item.id] === '裁判结果'"
                >
                  {{ item.judgment }}
                </div>
              </a-tab-pane>
            </a-tabs>
          </div>
        </div>
        <div class="case-footer">
          <div class="case-footer-item">
            <span>{{ item.cause }} •{{ item.dispute }}</span>
            <span>{{ item.trialLevel }}</span>
            <span>{{ item.area }}</span>
          </div>
          <div class="actions">
            <a-button type="link" @click="goView(item)"> 查看详情 </a-button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- 收藏弹窗 -->
  <a-modal
    v-model:open="favoriteModalVisible"
    title="选择收藏夹"
    @ok="handleFavoriteConfirm"
    :confirmLoading="favoriteConfirmLoading"
    okText="确定"
    cancelText="取消"
  >
    <a-select
      v-model:value="selectedFolderId"
      style="width: 100%"
      placeholder="请选择收藏夹"
    >
      <a-select-option
        v-for="folder in folderList"
        :key="folder.id"
        :value="folder.id"
      >
        {{ folder.name }}
      </a-select-option>
    </a-select>
  </a-modal>
</template>
<script setup>
import { ref, reactive, watch, onMounted, computed } from "vue";
import { message } from "ant-design-vue";

import {
  GetTree,
  BatchDownloadCases,
  BatchAddByArray,
  RemoveByCaseNumber,
} from "../../api/case/case";
import { getFolderList } from "../../api/collect/folder";
// import WorkbenchPagination from "./WorkbenchPagination.vue"
// import { FilterOutlined } from "@ant-design/icons-vue"
const props = defineProps({
  data: {
    type: Object,

    default: () => ({
      total: 0,

      list: [],
    }),
  },
  year: {
    type: Number,
    default: 0,
  },
  courtName: {
    type: String,
    default: "全部法院",
  },
  keyword: {
    type: String,
    default: "",
  },
});
// const emit = defineEmits(['update:year'])

// 内部副本，不直接修改prop
const innerYear = ref(props.year);
const courtNames = ref(props.courtName);
// 标记用户是否手动修改过法院值
const courtUserChanged = ref(false);

const downloadHover = ref(false);
const batchFavoriteHover = ref(false);
const favoriteModalVisible = ref(false);
const favoriteConfirmLoading = ref(false);
const folderList = ref([]);
const selectedFolderId = ref(undefined);
let pendingFavoriteCaseNumbers = []; // 暂存待收藏的案号

// 打开收藏弹窗，获取收藏夹列表
const openFavoriteModal = async (caseNumbers) => {
  pendingFavoriteCaseNumbers = caseNumbers;
  selectedFolderId.value = undefined;
  try {
    const res = await getFolderList();
    folderList.value = res?.data || [];
  } catch (err) {
    console.error("获取收藏夹列表失败", err);
    folderList.value = [];
  }
  favoriteModalVisible.value = true;
};

// 确定收藏
const handleFavoriteConfirm = async () => {
  if (!selectedFolderId.value) {
    message.warning("请选择一个收藏夹");
    return;
  }
  if (!pendingFavoriteCaseNumbers.length) {
    message.warning("没有待收藏的案例");
    return;
  }
  favoriteConfirmLoading.value = true;
  try {
    await BatchAddByArray({
      folderId: selectedFolderId.value,
      favoriteType: "类案检索",
      caseNumbers: pendingFavoriteCaseNumbers,
    });
    message.success("收藏成功");
    favoriteModalVisible.value = false;
    // 如果已收藏的数据集包含这些案号，更新 isFavorited
    pendingFavoriteCaseNumbers.forEach((ah) => {
      const item = caseList.value.find((i) => i.ah === ah);
      if (item) item.isFavorited = true;
    });
    // 同步源头数据（SearchHome.caseListData），否则下次重灌（新搜索等）会抹掉收藏状态
    emit("favoriteChange", {
      ahs: [...pendingFavoriteCaseNumbers],
      favorited: true,
    });
  } catch (err) {
    console.error("收藏失败", err);
    message.error("收藏失败");
  } finally {
    favoriteConfirmLoading.value = false;
  }
};
// 当 v-model 变化时，记录为用户手动操作
watch(courtNames, (v) => {
  if (!courtUserChanged.value && v !== props.courtName) {
    courtUserChanged.value = true;
  }
});
// const form = reactive({
//   keyword:'',
//   court: '全部法院',
//   year: 0
// })

const yearOptions = computed(() => {
  if (!innerYear.value) {
    // 从 caseList 中提取所有不重复的年份，降序排列
    const years = [
      ...new Set(caseList.value.map((item) => item.year).filter(Boolean)),
    ];
    years.sort((a, b) => b - a);
    return [
      { label: "全部", value: 0 },
      ...years.map((y) => ({ label: `${y}年`, value: y })),
    ];
  }
  return [
    { label: "全部", value: 0 },
    { label: `${innerYear.value}年`, value: innerYear.value },
  ];
});
const courtTreeData = ref([]);

// 根据选中的法院过滤树，只保留匹配节点
const courtTreeDataDisplay = computed(() => {
  const raw = courtTreeData.value;
  // 如果没有选中法院（全部法院），从 caseList 中提取所有法院生成选项
  if (!courtNames.value || courtNames.value === "全部法院") {
    const courts = [
      ...new Set(caseList.value.map((item) => item.court).filter(Boolean)),
    ];
    if (courts.length > 0 && (!raw || raw.length === 0)) {
      return [{ title: "全部法院", value: "全部法院", key: "全部法院" }];
    }
    if (courts.length > 0) {
      // 从已有地方法数据中筛选匹配的节点
      return filterTreeByCourts(raw, courts);
    }
    return raw;
  }
  // 递归查找匹配节点
  const findNode = (nodes) => {
    for (const node of nodes) {
      if (node.value === courtNames.value) return [node];
      if (node.children) {
        const found = findNode(node.children);
        if (found) return [{ ...node, children: found }];
      }
    }
    return null;
  };
  return findNode(raw) || raw;
});

// 从树形结构中筛选出包含指定法院名称的节点
const filterTreeByCourts = (nodes, courtNames) => {
  if (!nodes || !nodes.length) return nodes;
  const result = [];
  for (const node of nodes) {
    // 如果节点本身就是一个法院名称，只保留匹配的
    if (!node.children || !node.children.length) {
      if (courtNames.includes(node.title) || courtNames.includes(node.value)) {
        result.push(node);
      }
    } else {
      // 有子节点，在子节点中筛选
      const filteredChildren = filterTreeByCourts(node.children, courtNames);
      if (filteredChildren && filteredChildren.length > 0) {
        result.push({ ...node, children: filteredChildren });
      }
    }
  }
  return result;
};

// 加载法院树形数据
const loadCourtTree = async () => {
  try {
    const res = await GetTree();
    if (res.isSuccess && Array.isArray(res.data)) {
      courtTreeData.value = res.data;
    }
  } catch (err) {
    console.error("加载法院数据失败", err);
  }
};
onMounted(() => {
  loadCourtTree();
});
const emit = defineEmits([
  "detail",
  "goView",
  "pageChange",

  "sortChange",
  "download",
  "filter",
  "update:year",
  "search",
  "favoriteChange",
]);
const goView = (item) => {
  emit("goView", item);
};

// const activeKey = ref('案情摘要')
// 每个 item 独立的 activeKey，避免点击一个影响其他
const activeKeyMap = reactive({});

// 单条收藏/取消收藏
const toggleFavorite = async (item) => {
  if (item.isFavorited) {
    // 已收藏 → 取消收藏
    try {
      await RemoveByCaseNumber([item.ah]);
      message.success("取消收藏成功");
      item.isFavorited = false;
      emit("favoriteChange", { ahs: [item.ah], favorited: false });
    } catch (err) {
      console.error("取消收藏失败", err);
      message.error("取消收藏失败");
    }
  } else {
    // 未收藏 → 弹出收藏夹选择弹窗
    await openFavoriteModal([item.ah || ""]);
  }
};

// 批量收藏（选中的条目）
const batchFavorite = async () => {
  const checkedItems = caseList.value.filter((item) => item.checked);
  if (!checkedItems.length) {
    message.warning("请先勾选要收藏的案例");
    return;
  }
  const caseNumbers = checkedItems.map((item) => item.ah || "").filter(Boolean);
  await openFavoriteModal(caseNumbers);
};

const downloading = ref(false);

// 批量下载
const handleBatchDownload = async () => {
  const checkedItems = caseList.value.filter((item) => item.checked);
  if (!checkedItems.length) {
    message.warning("请先勾选要下载的案例");
    return;
  }

  const caseNumbers = checkedItems.map((item) => item.ah || "").filter(Boolean);
  if (!caseNumbers.length) {
    message.warning("所选案例无案号，无法下载");
    return;
  }

  downloading.value = true;
  try {
    const blob = await BatchDownloadCases({ caseNumbers });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `案例批量下载_${Date.now()}.zip`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
    message.success("下载成功");
  } catch (err) {
    console.error("批量下载失败", err);
    message.error("下载失败");
  } finally {
    downloading.value = false;
  }
};

const checkAll = ref(false);

const caseList = ref([]);

const filteredCaseList = computed(() => {
  let list = caseList.value;

  // 年份筛选
  if (
    innerYear.value !== 0 &&
    innerYear.value !== null &&
    innerYear.value !== undefined
  ) {
    list = list.filter((item) => item.year === String(innerYear.value));
  }

  // 法院筛选
  if (courtNames.value && courtNames.value !== "全部法院") {
    list = list.filter((item) => item.court === courtNames.value);
  }

  return list;
});

watch(
  () => props.data,
  (val) => {
    caseList.value = JSON.parse(JSON.stringify(val || []));
  },
  {
    immediate: true,
  },
);

/**
 * 加载更多
 */
// const loadMore = () => {

//   console.log("加载更多")

//   // 后续调用接口分页即可

// }
const onCheckAll = () => {
  caseList.value.forEach((item) => {
    item.checked = checkAll.value;
  });
};

// const changeSort=(value)=>{

// emit("sortChange",value)

// }

// const changePage=(page,pageSize)=>{

// emit("pageChange",{

// page,

// pageSize

// })

// }

/**
 * 根据案号滚动到对应项
 */
const scrollToCase = (ah) => {
  const searchNo = ah.replace(/\s+/g, "");
  const index = filteredCaseList.value.findIndex(
    (item) => item.ah.replace(/\s+/g, "") === searchNo,
  );
  // console.log(index,filteredCaseList.value,ah,'index')
  if (index === -1) return;
  // 滚动到对应位置
  const el = document.querySelector(`[data-case-index="${index}"]`);
  if (el) {
    el.scrollIntoView({ behavior: "smooth", block: "start" });
  }
};

defineExpose({
  scrollToCase,
});
</script>
<style scoped lang="less">
.case-panel {
  // margin-top:32px;
  background: rgba(255, 255, 255, 0.98);
  box-shadow: 0px 10px 28px 0px rgba(40, 68, 116, 0.05);
  border-radius: 0 0 16px 16px;
  border: 1px solid #e8edf5;
  border-top: none;
  padding: clamp(16px, 2.5vw, 24px) clamp(12px, 2vw, 21px);
  // margin-bottom: 188px;
}

/* ========================= */

.panel-header {
  display: flex;

  justify-content: space-between;

  align-items: center;

  margin-bottom: 20px;
}

.left {
  display: flex;

  align-items: center;

  gap: 14px;
}

.panel-title {
  font-weight: 600;
  font-size: 16px;
  color: #12213f;
}

.panel-count {
  font-weight: 500;
  font-size: 13px;
  color: #7e8b9f;
}

/* ========================= */

.card-list {
  display: flex;

  flex-direction: column;

  gap: 16px;
}

/* ========================= */

.case-card {
  background: #ffffff;

  border: 1px solid #e2e8f0;

  border-radius: 16px;

  padding: clamp(14px, 2vw, 22px);

  transition: 0.25s;
}

.case-card:hover {
  border-color: #1768ff;

  box-shadow: 0 10px 30px rgba(23, 104, 255, 0.08);
}

/* ========================= */

.card-top {
  display: flex;

  align-items: flex-start;
}

.title-box {
  flex: 1;

  margin-left: 14px;
}

/* ========================= */

.case-title {
  font-family: "小标宋体", "SimSun", serif;
  /* 自适应字号：最小18px，首选2.2vw，最大29px */
  font-size: clamp(18px, 2.2vw, 29px);
  /* 小标宋体标准加粗 */
  font-weight: bold;
  /* 自适应行高 */
  line-height: clamp(24px, 2.8vw, 38px);
  /* 文字常规黑色 */
  color: #000000;

  margin-bottom: 8px;
  display: flex;
  justify-content: space-between;
}
.case-right {
  display: flex;
  gap: 12px;
}
.right-one {
  background: #edf4ff;
  box-shadow: 0px 10px 28px 0px rgba(40, 68, 116, 0.05),
    0px 4px 12px 0px rgba(42, 68, 112, 0.02);
  border-radius: 6px 6px 6px 6px;
  font-weight: 400;
  font-size: 12px;
  color: #1768ff;
  padding: 0 8px;
}
.right-two {
  font-weight: 400;
  font-size: 12px;
  color: #b66f11;
  background: #fff5e8;
  box-shadow: 0px 10px 28px 0px rgba(40, 68, 116, 0.05),
    0px 4px 12px 0px rgba(42, 68, 112, 0.02);
  border-radius: 6px 6px 6px 6px;
  padding: 0 8px;
}
.right-img {
  display: flex;
  align-items: center;
  gap: 16px;
  // box-shadow: 0px 10px 28px 0px rgba(40, 68, 116, 0.05),
  //   0px 4px 12px 0px rgba(42, 68, 112, 0.02);
  .right-relevanceScore {
    font-weight: 400;
    font-size: 14px;
  }
  .relevance-bum {
    font-size: 16px;
    font-weight: 600;
    color: #1768ff;
  }
}
.right-icon {
  width: 16px;
  height: 16px;
  cursor: pointer;
  // CSS 变量能穿透 <use> 的 shadow tree，:deep 选择器进不去
  --star-stroke: #8b9dc3;
  --star-fill: transparent;
  transition: transform 0.2s ease;

  &:hover {
    transform: scale(1.2);
    --star-stroke: #1768ff;
    --star-fill: rgba(23, 104, 255, 0.15);
  }

  // 已收藏：实心蓝星（放在 hover 之后，hover 时保持实心）
  &.is-favorited {
    --star-stroke: #1768ff;
    --star-fill: #1768ff;
  }
}
.case-meta {
  font-size: 13px;

  color: #94a3b8;
}

/* ========================= */

.similarity {
  min-width: 70px;

  height: 34px;

  border-radius: 17px;

  background: #eef5ff;

  color: #1768ff;

  display: flex;

  align-items: center;

  justify-content: center;

  font-size: 14px;

  font-weight: 700;
}

/* ========================= */

.recommend {
  margin-top: 18px;

  background: #f8fbff;

  border-left: 4px solid #1768ff;

  padding: 14px 16px;

  border-radius: 8px;

  color: #31425e;

  line-height: 28px;

  font-size: 14px;
}

.label {
  color: #1768ff;

  font-weight: 700;
}

/* ========================= */

.summary {
  // margin-top:16px;

  font-family: "仿宋_GB2312", SimSun, serif;
  font-size: clamp(13px, 1.4vw, 16pt);
  font-weight: 400;
  line-height: clamp(20px, 2.4vw, 28pt);
  color: #52627b;
  white-space: pre-wrap;
  word-break: break-word;
  max-height: 120px;
  overflow-y: auto;
  padding: 12px 0;
}

/* ========================= */

.tab-content {
  font-size: 14px;
  line-height: 26px;
  color: #4e5969;
  white-space: pre-wrap;
  word-break: break-word;
  max-height: 300px;
  overflow-y: auto;
  padding: 12px 0;
}

/* ========================= */

.tag-box {
  margin-top: 16px;

  display: flex;

  flex-wrap: wrap;

  gap: 8px;
}

.tag-box :deep(.ant-tag) {
  border-radius: 14px;

  padding: 4px 10px;

  font-size: 12px;
}

/* ========================= */

.case-footer {
  margin-top: 18px;

  display: flex;

  justify-content: space-between;

  align-items: center;

  // border-top:1px solid #F1F5F9;

  padding-top: 16px;
}
.case-footer-item span {
  font-weight: 400;
  font-size: 13px;
  color: #6d7c93;
  margin-right: 8px;
}
.actions {
  display: flex;

  // gap:10px;
}

.actions :deep(.ant-btn) {
  // color:#64748B;
  font-weight: 400;
  font-size: 14px;
  color: #1768ff !important;
}

/* ========================= */

.pagination {
  margin-top: 28px;

  display: flex;

  justify-content: center;
}

/* ===================== 工具栏 ===================== */

.toolbar {
  display: flex;

  justify-content: space-between;

  align-items: center;

  margin: 22px 0;

  padding: 14px 18px;

  background: #ffffff;

  border: 1px solid #e8edf6;

  border-radius: 12px;

  flex-wrap: wrap;
  gap: 12px;
}
.icons {
  width: 16px;
  height: 16px;
  margin-right: 8px;
}

.btns {
  font-weight: 600;
  font-size: 13px;
  color: #31425e;
}
.toolbar-left {
  display: flex;

  align-items: center;

  gap: 10px;
}

.toolbar-right {
  display: flex;
  align-items: center;
  gap: 12px;
}

:deep(.ant-input) {
  resize: none;
  font-size: 15px;
}

:deep(.ant-picker),
:deep(.ant-select-selector) {
  border-radius: 8px !important;
}

:deep(.ant-btn-primary) {
  border-radius: 8px;
  padding: 0 24px;
}
.text-up {
  background: #ffffff;
  box-shadow: 0px 8px 24px 0px rgba(36, 70, 130, 0.08);
  border-radius: 10px 10px 10px 10px;
  border: 1px solid #d8e0ed;
  font-weight: 600;
  font-size: 14px;
  color: #31425e;
  text-shadow: 0px 8px 24px rgba(36, 70, 130, 0.08);
}
.icons {
  width: 20px;
  height: 20px;
  margin-right: 8px;
}
.text-recognition {
  background: #f2f7ff;
  box-shadow: 0px 8px 24px 0px rgba(36, 70, 130, 0.08);
  border-radius: 10px 10px 10px 10px;
  border: 1px solid #d9e7ff;
  font-weight: 600;
  font-size: 14px;
  color: #1768ff;
}
.text-recognition:hover {
  background: #f2f7ff;
  box-shadow: 0 8px 24px rgba(36, 70, 130, 0.08);
  border: 1px solid #d9e7ff;
  color: #1768ff;
  font-weight: 600;
}
// .select-year{
//   background: #FFFFFF;
//   box-shadow: 0px 8px 24px 0px rgba(36,70,130,0.08);
//   border-radius: 10px 10px 10px 10px;
//   border: 1px solid #D8E0ED;
//   font-weight: 600;
//   font-size: 15px;
//   color: #31425E;
// }
.year-select {
  position: relative;
  display: inline-block;
  background: #ffffff;
  box-shadow: 0px 8px 24px 0px rgba(36, 70, 130, 0.08);
  border-radius: 10px 10px 10px 10px;
  border: 1px solid #d8e0ed;
  font-weight: 600;
  font-size: 15px;
  color: #31425e;
}

.calendar-icon {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  width: 16px;
  height: 16px;
  z-index: 10;
  pointer-events: none;
}

.year-select :deep(.ant-select-selector) {
  padding-left: 34px !important;
}

.tree-select-icon {
  width: 16px;
  height: 16px;
  margin-right: 4px;
  vertical-align: middle;
  flex-shrink: 0;
}

.select-wrapper {
  display: inline-flex;
  align-items: center;
  background: #ffffff;
  box-shadow: 0px 8px 24px 0px rgba(36, 70, 130, 0.08);
  border-radius: 10px 10px 10px 10px;
  border: 1px solid #d8e0ed;
  font-weight: 600;
  font-size: 15px;
  color: #31425e;
  padding-left: 12px;
}

.select-wrapper :deep(.ant-select-selector) {
  border: none !important;
  box-shadow: none !important;
  background: transparent !important;
}
.button-search {
  background: linear-gradient(162deg, #1568ff 0%, #0f5ce6 100%);
  box-shadow: 0px 8px 24px 0px rgba(36, 70, 130, 0.08),
    0px 8px 18px 0px rgba(23, 104, 255, 0.2);
  border-radius: 10px 10px 10px 10px;
  border: 1px solid #1768ff;
  font-weight: 400;
  font-size: 14px;
  color: #ffffff;
}
// :where(.css-dev-only-do-not-override-z4nrqd).ant-btn-default:not(:disabled):hover {
//   color: #ffffff !important;

// }
.search-icon {
  width: 20px;
  height: 20px;
  margin-right: 8px;
  margin-bottom: 4px;
}
.search-textarea {
  margin-bottom: 8px;
}

:deep(.optimize-panel) {
  margin: 18px 0;
}

:deep(.search-input .ant-input:focus),
:deep(.search-input .ant-input-focused) {
  border-color: transparent !important;
  box-shadow: none !important;
}
/* 去掉底部蓝色下划线 */
:deep(.ant-tabs-ink-bar) {
  display: none !important;
}

/* tab 默认颜色 */
:deep(.ant-tabs-tab) {
  color: #738198 !important;
  font-weight: 400;
}

/* 选中状态：去掉蓝色 + 改成你想要的颜色 */
:deep(.ant-tabs-tab-active) {
  color: #1768ff !important;
  font-weight: 600;
}

/* hover（可选） */
:deep(.ant-tabs-tab:hover) {
  color: #1768ff;
}

/* 去掉整个 Tabs 底部 border */
:deep(.ant-tabs-nav::before) {
  border-bottom: none !important;
}

.toolbar :deep(.ant-btn) {
  border-radius: 8px;
}

.toolbar :deep(.ant-select-selector) {
  border-radius: 8px !important;
}

.toolbar :deep(.ant-checkbox-wrapper) {
  color: #31425e;
}

/* ========================= */

:deep(.ant-pagination-item) {
  border-radius: 8px;
}

:deep(.ant-pagination-item-active) {
  border-color: #1768ff;
}

:deep(.ant-pagination-item-active a) {
  color: #1768ff;
}

:deep(.ant-checkbox-wrapper) {
  color: #31425e;
}

:deep(.ant-select-selector) {
  border-radius: 8px !important;
}

/* ========================= */

@media (max-width: 1200px) {
  .panel-header {
    flex-direction: column;

    align-items: flex-start;

    gap: 14px;
  }

  .toolbar-right {
    flex-wrap: wrap;
  }
}

@media (max-width: 992px) {
  .toolbar {
    flex-direction: column;
    align-items: stretch;
  }

  .toolbar-left,
  .toolbar-right {
    flex-wrap: wrap;
    justify-content: flex-start;
  }

  .toolbar-right {
    width: 100%;
  }

  .year-select,
  .select-wrapper {
    width: 100% !important;
  }

  .year-select :deep(.ant-select),
  .select-wrapper :deep(.ant-tree-select) {
    width: 100% !important;
  }
}

@media (max-width: 768px) {
  .case-card {
    padding: 16px;
  }

  .card-top {
    flex-wrap: wrap;
  }

  .similarity {
    margin-top: 10px;
  }

  .case-footer {
    flex-direction: column;

    align-items: flex-start;

    gap: 12px;
  }

  .toolbar-left {
    flex-direction: column;
    align-items: flex-start;
  }
}
</style>
